import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../-LazyRoutePage"

const ExpirationDateReportDetailPage = lazy(
  () =>
    import(
      "../../../../components/WMS/Warehouses/ExpirationDateReportDetailPage"
    ),
)

export const Route = createFileRoute(
  "/_layout/WMS/warehouses/expiration-date-report/$id",
)({
  component: ExpirationDateReportDetailRoute,
})

function ExpirationDateReportDetailRoute() {
  return (
    <LazyRoutePage>
      <ExpirationDateReportDetailPage />
    </LazyRoutePage>
  )
}
